import { RouteConfig } from 'vue-router';
import homepageRoutes from './homepage';
import adminRoutes from './admin';
import serviceRoutes from './service';
import newsRoutes from './news';
import progressRoutes from './progress';
import projectRoutes from './project';
import residentRoutes from './resident';

const dashboardRoutes: RouteConfig = {
  path: '/dashboard',
  name: 'dashboard',
  component: () => import(/* webpackChunkName: 'dashboard' */ '@/pages/Dashboard.vue'),
  redirect: {
    name: 'home',
  },
  children: [
    homepageRoutes,
    adminRoutes,
    newsRoutes,
    progressRoutes,
    projectRoutes,
    residentRoutes,
    serviceRoutes,
  ],
  meta: {
    auth: true,
  },
};

export default dashboardRoutes;
